import { Container, Section } from "@/components/ui/section";
import { Card, CardContent } from "@/components/ui/card";
import { MessageSquare, FileText, TrendingUp } from "lucide-react";

const features = [
  {
    icon: MessageSquare,
    title: "Automated customer interviews",
    description: "Launch interviews at scale. Casey handles questions, follow-ups, clarifications, tone, and depth.",
  },
  {
    icon: FileText,
    title: "Instant stories & collateral",
    description:
      "From each interview, Casey generates case studies, customer stories, testimonials, user stories, insight summaries, and sales one-pagers.",
  },
  {
    icon: TrendingUp,
    title: "Customer understanding at scale",
    description: "Identify patterns across segments, industries, personas, and outcomes — all from real conversations.",
  },
];

export const Product = () => {
  return (
    <Section id="product" className="bg-gradient-to-br from-primary/5 to-accent/5">
      <Container>
        <div className="text-center mb-12 max-w-3xl mx-auto">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6 leading-tight">
            Meet Casey - your AI customer interviewer and storytelling engine.
          </h2>
          <p className="text-lg sm:text-xl text-muted-foreground leading-relaxed">
            Casey interviews your customers one-on-one, asks smart follow-ups, and turns every conversation into
            ready-to-use marketing and sales collateral - automatically.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 sm:gap-8">
          {features.map((feature, index) => (
            <Card key={index} className="border-border hover:shadow-[var(--shadow-soft)] transition-all duration-300">
              <CardContent className="p-6">
                <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mb-4">
                  <feature.icon className="w-6 h-6 text-primary" />
                </div>
                <h3 className="text-xl font-semibold text-foreground mb-3">{feature.title}</h3>
                <p className="text-muted-foreground leading-relaxed">{feature.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </Container>
    </Section>
  );
};
